import React, {forwardRef, useState} from "react";
import i18next from "i18next";
import {getImagePathWithTheme, isDarkMode} from "../../../../../src/utils";

const EmptyElement = forwardRef((props:{appState:any,element:any,onMouseDown:any,onMouseUp:any,onWheel:any,onDelete:any}, ref)=>{
    const [isHover,setIsHover] = useState(false);
    return (
        <div className={'flex-center'} style={{
            border: '1px solid var(--draw-file-not-exist-border-color)',
            borderRadius: '8px',
            height: '100%',
            width:'100%',
            position: 'relative',
            pointerEvents: 'all'
        }}
             onMouseEnter={()=>{
                 setIsHover(true)
             }}
             onMouseLeave={()=>{
                 setIsHover(false)
             }}
             onMouseDown={(event) => {
                 props.onMouseDown(event);
             }}
             onMouseUp={(event) => {
                 props.onMouseUp(event);
             }}
             onWheel={(event) => {
                 props.onWheel(event);
             }}>
            <span style={{color:isDarkMode()?'#666666':'#BAB8B8'}}>{i18next.t("OriginalFileNotFound")}</span>
            {
                isHover &&
                <img className={'img-14 cursor-pointer'} style={{position: 'absolute', right: '16px', top: '16px'}}
                     src={getImagePathWithTheme('draw_no_file_close')} onClick={()=>{
                         props.onDelete(props.element);
                }}/>
            }

        </div>
    )
})

export default EmptyElement;